/* Accordions for merchant-authored content.

   Two different shapes arrive from the admin rich-text editor, and neither
   carries any behaviour of its own:

     .panel-group > .panel       Bootstrap 3 collapse markup, kept from the
                                 previous theme. `.panel-collapse.in` marks
                                 the row that starts open, and data-parent
                                 on the trigger means "only one open at a
                                 time" in Bootstrap's vocabulary.

     .faq-wrapper > .faq-item    the newer shape used inside blog articles.
                                 It already ships a real <button> and a
                                 <span class="faq-icon">, so only state and
                                 wiring are missing.

   Both are normalised into the same disclosure widget here rather than in
   Liquid, because this markup lives inside page and article content the
   merchant edits — the theme only ever receives it as an opaque HTML blob.

   The collapsed styling is gated behind .pb-acc--ready, which is added
   below, so if this script fails to run every answer stays visible instead
   of being permanently hidden. */
(function () {
  var uid = 0;

  function nextId(prefix) {
    uid += 1;
    return prefix + '-' + uid;
  }

  /* The panel's children are moved into a wrapper so the open/close
     transition can run on grid-template-rows, which animates to the
     content's natural height without measuring anything in JS. That needs
     exactly one child, and merchant answers are usually several <p>s. */
  function wrapPanel(panel) {
    if (panel.firstElementChild && panel.firstElementChild.classList.contains('pb-acc__inner')) {
      return panel.firstElementChild;
    }

    var inner = document.createElement('div');
    inner.className = 'pb-acc__inner';

    while (panel.firstChild) inner.appendChild(panel.firstChild);
    panel.appendChild(inner);

    return inner;
  }

  /* Visibility of the panel is left entirely to CSS: `hidden` would win
     over the grid-rows transition and make every open/close instant, so a
     closed panel is collapsed to zero height and taken out of the
     accessibility tree with visibility instead. */
  function setOpen(row, open) {
    row.item.classList.toggle('is-open', open);
    row.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function build(container, rows, exclusive) {
    if (!rows.length) return;

    rows.forEach(function (row) {
      if (!row.panel.id) row.panel.id = nextId('PbAcc');
      wrapPanel(row.panel);

      row.item.classList.add('pb-acc__item');
      row.trigger.classList.add('pb-acc__trigger');
      row.panel.classList.add('pb-acc__panel');

      /* Bootstrap's trigger is an <a href="#collapseN">. Left alone it
         would navigate and jump the page on every click, and it announces
         itself as a link rather than as an expandable control. */
      if (row.trigger.tagName === 'A') {
        row.trigger.setAttribute('role', 'button');
        row.trigger.removeAttribute('href');
        row.trigger.setAttribute('tabindex', '0');
      }

      row.trigger.setAttribute('aria-controls', row.panel.id);

      if (!row.item.querySelector('.pb-acc__icon')) {
        var existing = row.trigger.querySelector('.faq-icon');
        var icon = existing || document.createElement('span');

        icon.className = 'pb-acc__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '';

        if (!existing) row.trigger.appendChild(icon);
      }

      setOpen(row, row.startOpen === true);

      function toggle(event) {
        event.preventDefault();

        var open = !row.item.classList.contains('is-open');

        if (open && exclusive) {
          rows.forEach(function (other) {
            if (other !== row) setOpen(other, false);
          });
        }

        setOpen(row, open);
      }

      row.trigger.addEventListener('click', toggle);

      // A native <button> already handles both keys; a role="button" anchor
      // handles neither Space nor, once href is gone, Enter.
      if (row.trigger.tagName === 'A') {
        row.trigger.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          toggle(event);
        });
      }
    });

    container.classList.add('pb-acc', 'pb-acc--ready');

    /* A link elsewhere on the site can still point at #collapse3, and the
       browser cannot scroll to a panel that starts collapsed. */
    var target = window.location.hash.slice(1);
    if (!target) return;

    rows.forEach(function (row) {
      if (row.panel.id !== target) return;
      if (exclusive) rows.forEach(function (other) { setOpen(other, false); });
      setOpen(row, true);
      row.item.scrollIntoView({ block: 'center' });
    });
  }

  document.querySelectorAll('.panel-group').forEach(function (group) {
    var exclusive = false;

    var rows = [];
    group.querySelectorAll(':scope > .panel').forEach(function (item) {
      /* Queried in priority order rather than as one selector list: a
         selector list matches whichever candidate comes first in the
         document, and .panel-heading wraps .panel-title, so it would
         always win and leave the real control — the anchor Bootstrap put
         there — unwired and unannounced. */
      var trigger =
        item.querySelector('.panel-title a, .panel-title button') || item.querySelector('.panel-heading');
      var panel = item.querySelector('.panel-collapse');
      if (!trigger || !panel) return;

      if (trigger.hasAttribute('data-parent')) exclusive = true;

      rows.push({
        item: item,
        trigger: trigger,
        panel: panel,
        startOpen: panel.classList.contains('in'),
      });
    });

    build(group, rows, exclusive);
  });

  document.querySelectorAll('.faq-wrapper').forEach(function (group) {
    var rows = [];

    group.querySelectorAll(':scope > .faq-item').forEach(function (item) {
      var trigger = item.querySelector('.faq-question');
      var panel = item.querySelector('.faq-answer');
      if (!trigger || !panel) return;

      // Blog articles never set this, so their rows are unaffected; it
      // exists for sections/faq.liquid's per-question "open by default".
      var startOpen = item.getAttribute('data-start-open') === 'true';

      rows.push({ item: item, trigger: trigger, panel: panel, startOpen: startOpen });
    });

    build(group, rows, false);
  });
})();
